import React from "react";
import { classNames } from "Utils/utils";

export const CareWatchPreviewRow = ({ label, children }) => (
  <div className="care-watch-preview-card__row">
    <span className="care-watch-preview-card__label">{label}</span>
    <div className="care-watch-preview-card__value">{children}</div>
  </div>
);

const CareWatchPreviewCard = ({
  title,
  hint,
  highlighted = false,
  className,
  children,
}) => (
  <div
    className={classNames(
      "care-watch-preview-card",
      highlighted && "care-watch-preview-card--highlight",
      className
    )}
  >
    <p className="care-watch-preview-card__title">{title}</p>
    {children ? <div className="care-watch-preview-card__fields">{children}</div> : null}
    {hint ? (
      <div className="care-watch-preview-card__foot">
        <p className="care-watch-preview-card__hint">{hint}</p>
      </div>
    ) : null}
  </div>
);

export default CareWatchPreviewCard;
